import {
  ContentfulEntry,
  flattenSys,
  getClient,
  pickFirst,
  RawContentfulCollection,
  RawContentfulEntry,
  unwrapClientError,
  unwrapResponse,
} from './common';
import { gql } from 'graphql-request';
import { HelpHomeTemplateType } from '../../Template/Help/HelpHomeTemplate';

export function getHelpHomePage(
  preview: boolean,
  smartlingLanguage: string,
): Promise<HelpHomeTemplateType> {
  return getClient(preview)
    .rawRequest(
      gql`
        query GetHelpHome($preview: Boolean!, $smartlingLanguage: String!) {
          helpHomePageCollection(
            limit: 1
            preview: $preview
            locale: $smartlingLanguage
            where: { urlSlug: "help" }
          ) {
            items {
              sys {
                id
              }
              headline
              # only populate single row
              frequentlyAskedQuestionsCollection(limit: 4) {
                items {
                  sys {
                    id
                  }
                  question
                  urlSlug
                  translated
                  linkedFrom(allowedLocales: [$smartlingLanguage]) {
                    faqCategoryCollection(limit: 1) {
                      items {
                        name
                        urlSlug
                      }
                    }
                  }
                }
              }
              # only populate 3 rows
              faqCategoriesCollection(limit: 9) {
                items {
                  name
                  urlSlug
                  description
                  icon {
                    url(transform: { format: PNG8 })
                  }
                  faqsCollection {
                    items {
                      question
                      urlSlug
                      translated
                    }
                  }
                }
              }
            }
          }
        }
      `,
      { preview, smartlingLanguage },
    )
    .catch(unwrapClientError)
    .then(
      unwrapResponse<{ helpHomePageCollection: RawContentfulCollection }>(
        'help',
      ),
    )
    .then(data => data.helpHomePageCollection)
    .then(pickFirst('help'))
    .then((helpHomePage: RawContentfulEntry) => ({
      id: helpHomePage.sys.id,
      contentType: 'helpHomePage',
      headline: helpHomePage.headline,
      frequentlyAskedQuestions:
        helpHomePage.frequentlyAskedQuestionsCollection.items
          .map(flattenSys('faq'))
          .map((faq: ContentfulEntry) => ({
            ...faq,
            category: faq.linkedFrom?.faqCategoryCollection?.items?.[0],
          })),
      faqCategories: helpHomePage.faqCategoriesCollection.items.map(
        (faqCategory: any) => ({
          ...faqCategory,
          faqs:
            smartlingLanguage === 'en-US'
              ? faqCategory.faqsCollection.items
              : faqCategory.faqsCollection.items.filter(
                  (item: any) => item.translated,
                ),
        }),
      ),
      modules: [],
    }));
}
